



  import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"Blog"
})
export default class Blog extends Vue {}
